import { QRCodeSVG } from "qrcode.react";
import { Queue } from "@/types/queue";
import { useQueues } from "@/hooks/useQueues";
import { LoadingSpinner } from "@/components/LoadingSpinner";

export const AllQRCodesView = () => {
  const { queues, isLoading } = useQueues();
  
  if (isLoading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }

  if (!queues.length) {
    return (
      <div className="min-h-screen bg-background p-8">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-3xl font-bold mb-4">No Active Queues</h1>
          <p className="text-muted-foreground">Create a queue first to generate QR codes.</p>
        </div>
      </div>
    );
  }
  
  return (
    <div className="min-h-screen bg-background p-8">
      <div className="max-w-7xl mx-auto space-y-12">
        <h1 className="text-3xl font-bold text-center mb-8 bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
          Queues
        </h1>
        
        {queues.map((queue) => (
          <div key={queue.id} className="space-y-6">
            <h2 className="text-2xl font-semibold border-b pb-2">{queue.name}</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div className="bg-card p-6 rounded-xl shadow-lg border border-muted/20 space-y-4">
                <div className="bg-secondary p-4 rounded-xl shadow-sm">
                  <QRCodeSVG
                    value={`https://join.qninja.dev?uid=${queue.id}`}
                    size={200}
                    level="H"
                    className="mx-auto"
                  />
                </div>
                <div className="text-center space-y-2">
                  <p className="text-sm text-muted-foreground">
                    Scan to join the queue
                  </p>
                  <p className="text-xs text-muted-foreground/70">
                    {queue.name}
                  </p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};